// Google Analytics gtag interface
interface GtagFunction {
  (
    command: 'event',
    eventName: string,
    eventParams?: Record<string, unknown>
  ): void;
  (command: 'config', targetId: string, config?: Record<string, unknown>): void;
  (command: 'js', date: Date): void;
}

declare global {
  interface Window {
    gtag?: GtagFunction;
    dataLayer?: unknown[];
  }
}

/**
 * Track a custom event with Google Analytics
 * @param eventName - The name of the event (e.g., 'click', 'download')
 * @param eventParams - Additional parameters for the event
 */
export function trackEvent(
  eventName: string,
  eventParams?: Record<string, unknown>
): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * Track a download button click
 * @param location - The location of the button (e.g., 'header', 'hero', 'features')
 */
export function trackDownloadClick(location: string): void {
  trackEvent('click', {
    event_category: 'Downloads',
    event_label: location,
    value: 1,
  });
}
